import React from 'react';
import ReactDOM from 'react-dom';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import { FaFacebook } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";

export default function Footer(){
    return (
        <footer className='pb-5 pt-5 text-center text-white'>
             <Navbar expand="lg" data-bs-theme="dark">
                <Container className='border-bottom botter-secondary'>
                    <Navbar.Brand href="#home">React-Bootstrap</Navbar.Brand>
                    <Navbar>
                        <Nav className="me-auto flex-wrap" navbarScroll>
                            <Nav.Link href="#home">Home</Nav.Link>
                            <Nav.Link href="#link">About</Nav.Link>
                            <Nav.Link href="#link">Services</Nav.Link>
                            <Nav.Link href="#link">Article</Nav.Link>
                            <Nav.Link href="#link">Projects</Nav.Link>
                            <Nav.Link href="#link">Contact</Nav.Link>
                        </Nav>
                    </Navbar>
                    <Navbar.Text>
                        <Button variant='secondary' className='ms-3'><FaFacebook /></Button>
                        <Button variant='secondary' className='ms-3'><FaTwitter /></Button>
                        <Button variant='secondary' className='ms-3'><FaLinkedin /></Button>
                    </Navbar.Text>
                </Container>
                </Navbar>
                <div className="text-center mt-4">© 2025 bigsauda.com</div>
        </footer>
    )
}

